import React, { useState } from 'react';
import { string, func, array, bool } from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import { size, includes } from 'lodash';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import { Row, FormDatePicker, FormSelect, Button, SalesChannelByCompanySelect } from '../../common';

const SpaceBetween = styled.div`
    width: ${({ width }) => width};
`;

const Filters = ({ currentValue, onSubmitFilters, exclude, isAuditMonitor, multiple, allSelected, fromResume, withoutStoreKind }) => {
    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';
    const statusOptions = [
        { value: [1, 2, 20, 30].join('-'), label: 'Pendiente de picking' },
        { value: [3].join('-'), label: 'En Picking' },
        { value: [7].join('-'), label: 'Por completar' },
        { value: [4].join('-'), label: 'Pickeado por facturar' }
    ];
    const slaOptions = [
        { label: 'Despacho Express', value: 'express' },
        { label: 'Retiro en Tienda', value: 'tienda' },
        { label: 'Retiro al Auto', value: 'auto' },
        { label: 'Despacho a Domicilio', value: 'domicilio' },
        { label: 'Despacho Especial', value: 'especial' }
    ];
    const [status, setStatus] = useState([{ value: [1, 2, 20, 30].join('-'), label: 'Pendiente de picking' }]);
    const [salesChannel, setSalesChannel] = useState([]);
    const [dateSelected, setDateSelected] = useState({ init: `${moment().format('YYYY-MM-DD')} 00:00:00`, end: `${moment().add(1, 'days').format('YYYY-MM-DD')} 00:00:00` });
    const [slas, setSlas] = useState(slaOptions);
    const isArrayNill = (array) => size(array) < 1;
    const fieldIsExcluded = name => includes(exclude, name);
    const buttonIsDisabled = () => isArrayNill(salesChannel) || isArrayNill(status) || isArrayNill(slas);
    const defaultDate = isAuditMonitor && moment().subtract(1, 'months');

    const salesChannelByCompanySelectProps = { withoutStoreKind, multiple, allSelected, fromResume, onChangeSalesChannels: setSalesChannel };

    return (
        <FlexContainer padding={23}>
            <Row
                border='1px solid #eaeaea'
                borderRadius={3}
                padding='3px 13px'
                noWrap={!fullWidth}
                backgroundColor='white'
            >
                {!fieldIsExcluded('datePicker') && <FormDatePicker
                    range
                    label='Día'
                    width='100%'
                    defaultValue={defaultDate}
                    onChange={values => setDateSelected({
                        init: `${moment(values[0]).format('YYYY-MM-DD')} 00:00:00`,
                        end: `${moment(values[1]).add(1, 'days').format('YYYY-MM-DD')} 00:00:00`
                    })}
                />}
                <SpaceBetween width={spaceBetweenWidth} />
                <SalesChannelByCompanySelect {...salesChannelByCompanySelectProps} />
                <SpaceBetween width={spaceBetweenWidth} />
                { !fieldIsExcluded('status') && <FormSelect
                    multiple
                    label='Estado'
                    options={statusOptions}
                    onChange={({ value }) => setStatus(value)}
                    value={status}
                />}
                <SpaceBetween width={spaceBetweenWidth} />
                { !fieldIsExcluded('slas') && <FormSelect
                    multiple
                    label='Servicio'
                    options={slaOptions}
                    onChange={({ value }) => setSlas(value)}
                    value={slas}
                />}
                <SpaceBetween width={spaceBetweenWidth} />
                <FlexContainer
                    width={fullWidth ? '100%' : undefined}
                    align='flex-end'
                    mB={10}
                >
                    <Button
                        textTransform='uppercase'
                        text='Buscar'
                        disabled={buttonIsDisabled()}
                        onClick={() => onSubmitFilters({ salesChannels: salesChannel, status, dateSelected, slas })}
                    />
                </FlexContainer>
            </Row>
        </FlexContainer>
    );
};

Filters.propTypes = {
    currentValue: string,
    isAuditMonitor: bool,
    onSubmitFilters: func,
    exclude: array,
    multiple: bool,
    allSelected: bool,
    fromResume: bool,
    withoutStoreKind: bool
};

Filters.defaultProps = {
    currentValue: '100%',
    onSubmitFilters: () => {},
    exclude: [],
    isAuditMonitor: false,
    multiple: true,
    allSelected: true,
    fromResume: false,
    withoutStoreKind: false
};

export default Filters;
